import { Task } from "@lit/task";
import { progressInstance } from "@nx-paeonia/utils-events";
import { map, mapErr } from "@nx-paeonia/utils-result";
import { removeFromCart, updateCartItem } from "@nx-paeonia/utils-shopify";
import type { ReactiveControllerHost } from "lit";
import type { CartLineItemComponent } from "../components/cart-line-item.component.js";
import { renderCartSection } from "../helpers/render.helper.js";
import { TaskReactiveController } from "./TaskReactiveController.js";

type LineItemId = string;
type NewQuantity = number;
type InputParameters = [LineItemId, NewQuantity];

export class QuantityController extends TaskReactiveController {
	public readonly updateQuantityTask = new Task<InputParameters>(this._host, async ([lineItemId, newQuantity]) => {
		progressInstance.start();

		const res = await updateCartItem({
			id: lineItemId,
			quantity: newQuantity,
			sections: ["cart-overlay"],
		});

		mapErr(res, (err) => {
			console.warn(err);
			progressInstance.done();
		});

		map(res, ({ sections }) => {
			if (sections) {
				progressInstance.set(80);
				renderCartSection(sections);
			}

			progressInstance.done();
		});
	});

	public readonly removeProductTask = new Task<[string]>(this._host, async ([lineItemId]) => {
		progressInstance.start();

		const res = await removeFromCart(lineItemId);
		mapErr(res, (err) => {
			console.warn(err);
			progressInstance.done();
		});

		map(res, ({ sections }) => {
			if (sections) {
				progressInstance.set(80);
				renderCartSection(sections);
			}

			progressInstance.done();
		});
	});

	constructor(private readonly _host: ReactiveControllerHost & CartLineItemComponent) {
		super();
	}
}
